<template>
  <div class="container my-5">
    <div class="row display-flex">
      <div class="col-lg-5 col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2 class="card-title text-truncate mb-0">Customer</h2>
              </div>
            </div>
            <h5>Contact Information</h5>
            <div class="row gx-0">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate strong mb-0">
                  <i class="far fa-fw fa-building"></i>
                  <router-link
                    tag="a"
                    :to="{
                      name: 'clients.show',
                      params: { client_id: stack.client.id },
                    }"
                    target="_blank"
                  >
                    {{ stack.client.company }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2>Stack Details</h2>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-sm btn-link"
                  v-c-modal:modal="{}"
                >
                  <i class="far fa-pencil-alt"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <p>
                  <span class="data-label">Name</span>
                  {{ stack.name }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Created</span>
                  {{ stack.created_at | moment("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">AWS Account ID</span>
                  <a v-bind:href="awsLink">{{ stack.aws_account_id }}</a>
                  
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Auto Bill</span>
                  <span
                    v-bind:class="stack.auto_bill ? 'status-success' : 'status-mute'"
                    class="status"
                    >{{ stack.auto_bill ? 'Enabled' : 'Disabled' }}</span
                  >
                </p>
              </div>
              <div class="col-6">
                <p>
                  <span class="data-label">Monthly Charge</span>
                  ${{ stack.pi_monthly_total | currency }}
                </p>
              </div>
              <div class="col-6">
                <p>
                  <span class="data-label">Pre-paid Credit</span>
                  ${{ stack.pre_paid_credit | currency }}
                </p>
              </div>
              <div class="col-6">
                <p>
                  <span class="data-label">Practice Ignition Service</span>
                  {{ stack.pi_service }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <a href="#" class="text-danger" @click="confirmDelete"
          >Delete Stack</a
        >
      </div>
    </div>

    <stacks-modal
      ref="modal"
      title="Edit Stack"
      :stack="stack"
      mode="edit"
    ></stacks-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import StacksModal from "./StacksModal";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    StacksModal,
  },
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("stack", {
      stack: "single",
    }),
    awsLink() {
      return 'https://signin.aws.amazon.com/switchrole?roleName=OrganizationAccountAccessRole&account='+this.stack.aws_account_id+'&displayName='+this.stack.terraform_workspace_name+'&color=FBBF93'
    }
  },

  methods: {
    ...mapActions("stack", {
      getStack: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),

    confirmDelete() {
      this.$swal({
        title: "Confirm Delete",
        html: "Are you sure you want to delete this stack",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteSingle(this.stack.id).then(
            this.$router.push({ name: "stacks.index" })
          );
        },
        function () {}
      );
    },
  },
};
</script>
